// extracted by mini-css-extract-plugin
export default {"iconCollapse":"IconCollapse_iconCollapse__3aUll"};